/**
 * @title  validateConnector
 * @author Holger Schauf
 * @type   connector
 * @desc   connect elements handler with validators
 * @date   06.2013
 */
var validateConnector = (function ($) {
    return Class.extend({
        rules: {},
        msg: null,
        storage: false,
        options: {},

        elmString: null,
        container: null,
        type: null,
        skipValidation: false,
        htmlCreated: false,

        init: function (data, form) {
            this.elm = $(form).find(data.elm);
            this.filled = false;
            this.status = true;
            this.valid = false;

            this.rules = data.rules;
            this.msg = data.msg || false;
            this.storage = data.storage || false;
            this.options = data.options ? data.options : {};
            this.callback = data.callback || false;
            this.preventOutput = false;

            this.elmString = data.elm.split(', ');

            this.elm.on('change', $.shove(this.changeCheck, this));

            this.container = this.elm.parent();

            this.preValididation(data.cfg.preValidation);

            this.checkSkipFilled();

            // fix for desktop local storage use
            if (!ApplicationProperties.get('mobile')) {
                try {
                    for (var item in window.localStorage) {
                        if (/^personal\./.test(item)) {
                            stj.global.removeLocalStorage(item);
                        }
                    }
                } catch (e) {}
            }
        },

        initHtml: function () {
            if (!this.msg) {
                return false;
            }

            var okVisibility = this.status ? 'block' : 'none';
            if (this.container.hasClass('inline-block-icon')) {
                okVisibility = this.status ? 'inline-block' : 'none';
            }
            var html = '';
            for (var key in this.rules) {
                if (this.container.find('.error-message-' + key).length === 0) {
                    if (this.container.hasClass('set-bottom')) {
                        html +=
                            '<span class="error-message error-message-' +
                            key +
                            ' grd-68 psr error-msg-arw-top bgc-red mgn-b-10 brs-sld-1 brc-red bxs-m rnd-m zdx-2" style="display:none"><p class="fns-12 pdg-10">' +
                            js_tr.error[this.msg[key]] +
                            '</p></span>';
                    } else if (
                        this.container.hasClass('psr') &&
                        !this.container.hasClass('set-bottom')
                    ) {
                        html +=
                            '<span class="error-message error-message-' +
                            key +
                            ' grd-68 psn-rgt-out-top-abs error-msg-arw-lft bgc-red mgn-b-10 brs-sld-1 brc-red bxs-m rnd-m zdx-2" style="display:none"><p class="fns-12 pdg-10">' +
                            js_tr.error[this.msg[key]] +
                            '</p></span>';
                    } else {
                        html +=
                            '<p class="error-message error-message-' +
                            key +
                            '" style="display:none">' +
                            this.getErrorMessage(this.rules[key], key) +
                            '</p>';
                    }
                }
            }

            if (this.container.find('.icon-ok').length === 0) {
                html +=
                    '<i class="icon-ok glyph fns-15 clr-grn flt-rgt mgn-t-7" style="display:' +
                    okVisibility +
                    '">D</i>';
            }

            this.container.append(html);

            this.htmlCreated = true;
        },

        getErrorMessage: function (value, key) {
            var message = js_tr.error[this.msg[key]];

            if (typeof message !== 'undefined') {
                return message.replace(':value', value);
            }

            if (ApplicationProperties.get('debug')) {
                console.log('no translation found with key:', {
                    key: key,
                    value: value,
                });
            }
            return '';
        },

        checkSkipFilled: function () {
            if (
                this.elm.length === 1 &&
                $.inArray($(this.elm).attr('type'), ['checkbox', 'radio'])
            ) {
                this.skipValidation = true;
            }
        },

        preValididation: function (check) {
            if (check !== true) {
                return false;
            }

            if (this.container.hasClass('error')) {
                this.status = false;
                this.valid = false;
                return false;
            }

            var filled = true;

            this.elm.each(function () {
                if ($(this).val().length === 0) {
                    filled = false;
                }
            });

            this.preventOutput = true;
            this.validate(true);
            this.preventOutput = false;
        },

        check: function (forceValidate) {
            if (!this.htmlCreated) {
                this.initHtml();
            }

            if (typeof forceValidate === 'undefined') {
                forceValidate = false;
            }

            var filled = true;

            this.elm.each(function () {
                if ($(this).val().length === 0) {
                    filled = false;
                }
            });

            this.filled = filled;

            if (
                forceValidate ||
                this.skipValidation ||
                this.filled ||
                this.valid
            ) {
                this.validate();
            }
        },

        validate: function (omitTracking) {
            omitTracking = omitTracking || false;
            var checkStatus = true;
            var self = this;

            this.status = true;

            this.elm.each(function () {
                for (var rule in self.rules) {
                    checkStatus =
                        rule !== 'type'
                            ? validators[rule](self.rules[rule], $(this))
                            : validators[self.rules[rule]]($(this), self);

                    if (checkStatus === false && $(this).is(':visible')) {
                        if (!omitTracking) {
                            var track = new actionTracking({
                                acTrAc: 'pdata_error_fields',
                                acTrLa: self.getNameForTracking($(this)),
                            });
                            track.push();
                        }
                        self.status = false;
                        self.showMessage(self.msg[rule], rule);
                        return;
                    }
                }
            });

            if (this.status === true) {
                for (var rule in this.rules) {
                    this.removeMessage(rule);
                }

                this.filled = true;
                this.valid = true;

                if (this.callback !== false) {
                    this.callback();
                }

                this.showOk();
            } else {
                this.valid = false;
            }

            return this.valid;
        },

        showMessage: function (msg, rule) {
            if (this.preventOutput === true) {
                return false;
            }

            this.container.removeClass('success-input');

            this.container.removeClass(function (elm, css) {
                return (css.match(/error-(\w+)/g) || []).join(' ');
            });

            this.container.addClass('error error-' + rule);

            this.container.find('.icon-ok').hide();
            this.container.find('.icon-no').show();
        },

        removeMessage: function (rule) {
            var serverSideError = this.container.find('p.error');
            if (serverSideError.length) {
                serverSideError.hide();
            }
            this.container.removeClass('error error-' + rule);
        },

        clear: function () {
            this.elm.each(function () {
                $(this).val('');
            });
        },

        showOk: function () {
            if (this.preventOutput === true) {
                return false;
            }

            this.container.find('.icon-ok').show();
            this.container.find('.icon-no').hide();

            this.container.addClass('success-input');
        },

        changeCheck: function () {
            this.check();

            if (
                mobile &&
                stj.global.isLocalStorageSupported() &&
                this.storage
            ) {
                this.setLocalStorage(this.elm, this.elmString, this.storage);
            }
        },

        setLocalStorage: function (elm, elmString, storage) {
            if (elm.length === 0) {
                return;
            }

            if (
                elmString instanceof Array &&
                storage !== undefined &&
                storage.enabled
            ) {
                var elmsLength = elmString.length;
                try {
                    for (var i = 0; i < elmsLength; i++) {
                        var item;
                        var elemId = $(elmString[i]).attr('id');

                        var storageIdentifier = 'personal.' + elemId;

                        // We do not want to save the email and/or password inside the localstorage
                        if (
                            'customerPassword' === elemId ||
                            'customerEmail' === elemId
                        ) {
                            if (stj.global.getLocalStorage(storageIdentifier)) {
                                // Make sure it will be cleared if it already exists
                                stj.global.removeLocalStorage(
                                    storageIdentifier
                                );
                            }
                            continue;
                        }

                        if (
                            storage.type === 'checkbox' ||
                            storage.type === 'radio'
                        ) {
                            if ($(elmString[i]).prop('checked')) {
                                item = 'checked';
                                stj.global.setLocalStorage(
                                    storageIdentifier,
                                    item
                                );
                            } else {
                                stj.global.removeLocalStorage(
                                    storageIdentifier
                                );
                            }
                        } else {
                            item = $(elmString[i]).val();
                            stj.global.setLocalStorage(storageIdentifier, item);
                        }
                    }
                } catch (e) {}
            }
        },

        getNameForTracking: function ($elm) {
            var name = 'unknown';

            if ($elm.attr('name') && $elm.attr('type') !== 'radio') {
                name = $elm.attr('name');
            } else if ($elm.attr('name') && $elm.attr('type') === 'radio') {
                name = $elm.attr('name') + '_' + $elm.attr('value');
            } else if ($elm.attr('id')) {
                name = 'id: ' + $elm.attr('id');
            } else if ($elm.attr('class')) {
                name = 'class:' + $elm.attr('class');
            }

            return name.replace(/\d+/g, '').replace(/\s+/g, '_');
        },
    });
})(jQuery);
